<template>
  <div class="modal fade" id="update-solicitation" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content content">
        <div class="modal-header">
          <a type="button" class="close-btn-solicitation" data-dismiss="modal">
            <ion-icon name="close"></ion-icon>
          </a>
          <div class="title-group">
            <h4 class="title-modal">{{ titleModal }}</h4>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="typeModal === 1" class="body-default">
            <span>ID:
              <b v-if="valueModal.solicitationData.id">{{ valueModal.solicitationData.id }}</b>
              <b v-else>-</b>
            </span>
            <span>Unidade de Negócio:
              <b v-if="valueModal.solicitationData.businessUnit">{{ valueModal.solicitationData.businessUnit }}</b>
              <b>-</b>
            </span>
            <span>Plano:
              <b v-if="valueModal.solicitationData.plan">{{ valueModal.solicitationData.plan }}</b>
              <b v-else>-</b>
            </span>
            <span>Valor do plano:
              <b v-if="valueModal.solicitationData.planValue">{{ valueModal.solicitationData.planValue }}</b>
              <b v-else>-</b>
            </span>
            <span>Valor benefício:
              <b v-if="valueModal.solicitationData.benefitsValue">{{ valueModal.solicitationData.benefitsValue }}</b>
              <b v-else>-</b>
            </span>
            <span>Cobrar a partir de que mês:
              <b v-if="valueModal.solicitationData.changeFrom">{{ valueModal.solicitationData.changeFrom }}</b>
              <b v-else>-</b>
            </span>
          </div>
          <div class="body-input">
            <div v-if="typeModal === 1">
              <div class="form-select">
                <label>Status</label>
                <div class="form-select-input">
                  <select v-model="valueModal.solicitationData.status">
                    <option :value="0">Não definido</option>
                    <option :value="1">Pendente</option>
                    <option :value="2">Em Progresso</option>
                    <option :value="3">Entregue</option>
                    <option :value="4">Cancelado</option>
                  </select>
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </div>
              </div>
              <div class="form-select" style="margin-top: 20px;">
                <label>Unidade de negócio</label>
                <div class="form-select-input">
                  <select v-model="valueModal.solicitationData.businessUnitId">
                    <option v-for="(unit, index) in valueModal.businessUnitChange" :key="index"
                            :value="unit.id">{{ unit.name }}
                    </option>
                  </select>
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </div>
              </div>
              <div class="form-textarea padding-null form-group">
                <label>Adicionar observação</label>
                <textarea v-model="newNote" class="form-control" id="description" rows="5"
                          placeholder="Digite uma observação"
                          cols="10"
                          maxlength="2000"></textarea>
              </div>
            </div>
            <div v-if="typeModal === 2">
              <div class="form-text">
                <label>Nome</label>
                <div class="form-text-input">
                  <input v-model="valueModal.requesterData.name" type="text" placeholder="Digite um nome"
                         autocomplete="off">
                </div>
              </div>
              <div class="form-text">
                <label>Telefone</label>
                <div class="form-text-input">
                  <input v-model="valueModal.requesterData.phone" type="text" placeholder="Digite um telefone"
                         autocomplete="off">
                </div>
              </div>
              <div class="form-text">
                <label>E-mail</label>
                <div class="form-text-input">
                  <input v-model="valueModal.requesterData.email" type="text" placeholder="Digite um e-mail"
                         autocomplete="off">
                </div>
              </div>
            </div>
            <div v-if="typeModal === 3">
              <div class="form-select">
                <label>Forma de envio</label>
                <div class="form-select-input">
                  <select v-model="valueModal.shippingData.deliveryOptions">
                    <option :value="0">Não definido</option>
                    <option :value="1">Sedex</option>
                    <option :value="2">Pessoalmente</option>
                  </select>
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </div>
              </div>
              <div class="form-text" style="margin-top: 20px;">
                <label>Rastreio</label>
                <div class="form-text-input">
                  <input v-model="valueModal.shippingData.trackCode" v-mask=""
                         type="text"
                         placeholder="Digite um código de rastreio "
                         autocomplete="off">
                </div>
              </div>
            </div>
            <div class="row" v-if="typeModal === 4">
              <div class="form-text col-md-6" style="padding: 0 15px;">
                <label style="position: relative;">CEP<span v-if="validateCep">CEP incorreto</span></label>
                <div class="form-text-input">
                  <input @keyup="completeCep()" v-model="valueModal.addressData.zipCode" v-mask="['#####-###']"
                         type="text"
                         placeholder="Digite um código de rastreio "
                         autocomplete="off">
                </div>
              </div>
              <div class="form-text col-md-6" style="margin-top: 0; padding: 0 15px;">
                <label>País</label>
                <div class="form-text-input">
                  <input v-model="valueModal.addressData.country" type="text"
                         placeholder="Digite um código de rastreio "
                         autocomplete="off">
                </div>
              </div>
              <div class="form-text col-md-6" style="padding: 0 15px;">
                <label>Estado</label>
                <div class="form-text-input">
                  <input v-model="valueModal.addressData.state" type="text"
                         placeholder="Digite um código de rastreio "
                         autocomplete="off">
                </div>
              </div>
              <div class="form-text col-md-6" style="padding: 0 15px;">
                <label>Cidade</label>
                <div class="form-text-input">
                  <input v-model="valueModal.addressData.city" type="text"
                         placeholder="Digite um código de rastreio "
                         autocomplete="off">
                </div>
              </div>
              <div class="form-text col-md-9" style="padding: 0 15px;">
                <label>Rua</label>
                <div class="form-text-input">
                  <input v-model="valueModal.addressData.street" type="text"
                         placeholder="Digite um código de rastreio "
                         autocomplete="off">
                </div>
              </div>
              <div class="form-text col-md-3" style="padding: 0 15px;">
                <label>Numero</label>
                <div class="form-text-input">
                  <input v-model="valueModal.addressData.number" type="text"
                         placeholder="Digite um código de rastreio "
                         autocomplete="off">
                </div>
              </div>
            </div>
            <div class="input-btn">
              <span class="btn-cancel" data-dismiss="modal">Cancelar</span>
              <button class="btn-save" @click="saveChanges()" :disabled="loading || validateCep">
                <span v-if="!loading">Salvar</span>
                <div class="loading-btn" v-else>
                  <div class="spinner-btn">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../requestConfig";
import {CEP_GLOBAL, CHANGE_STATUS_SUMMARY} from "../../../urlConfig";
import swal from "sweetalert";
import axios from "axios";

export default {
  name: "modalUpdateSolicitation",
  props: {
    typeModal: {
      required: true,
    },
    titleModal: {
      required: true,
    },
    valueModal: {
      required: true,
    },
    runFunction: {
      type: Function,
    },
  },
  data() {
    return {
      loading: false,
      loadingCep: false,
      validateCep: false,
      newNote: '',
    }
  },
  methods: {
    completeCep() {
      if (this.valueModal.addressData.zipCode.length === 9 && !this.loadingCep) {
        this.loadingCep = true;
        axios.get(CEP_GLOBAL + this.valueModal.addressData.zipCode + '/json')
          .then((response) => {
            UTIL_SERVICE.console("RESULT CEP_GLOBAL:", response.data);

            if (response.data.erro) {
              this.loadingCep = false;
              return this.validateCep = true
            }

            this.validateCep = false

            this.valueModal.addressData.city = response.data.localidade;
            this.valueModal.addressData.state = response.data.uf;
            this.valueModal.addressData.street = response.data.logradouro;
            this.valueModal.addressData.number = '';

            this.loadingCep = false;
          })
          .catch((reason) => {
            this.loadingCep = false;
          });
      }
    },
    saveChanges() {
      this.loading = true;

      if (this.typeModal !== 1) {
        this.newNote = '';
      }

      let obj = {
        companyId: this.valueModal.additionalData.companyId,
        contactName: this.valueModal.requesterData.name,
        contactEmail: this.valueModal.requesterData.email,
        contactPhone: this.valueModal.requesterData.phone,
        status: this.valueModal.solicitationData.status,
        drawerCards: this.valueModal.additionalData.drawerCards,
        qtdUsers: this.valueModal.additionalData.qtdUsers,
        trackCode: this.valueModal.shippingData.trackCode,
        deliveryOptions: this.valueModal.shippingData.deliveryOptions,
        contextCode: this.valueModal.additionalData.contextCode,
        notes: this.newNote,
        street: this.valueModal.addressData.street,
        number: this.valueModal.addressData.number,
        neighborhood: this.valueModal.additionalData.neighborhood,
        complement: this.valueModal.additionalData.complement,
        city: this.valueModal.addressData.city,
        state: this.valueModal.addressData.state,
        country: this.valueModal.addressData.country,
        zipCode: this.valueModal.addressData.zipCode,
        longitude: this.valueModal.additionalData.latitude,
        latitude: this.valueModal.additionalData.longitude,
        id: this.valueModal.solicitationData.id,
        createdAt: this.valueModal.additionalData.createdAt,
        cardOrderId: this.valueModal.solicitationData.id,
        uid: this.$route.params.userInfo.id,
        businessUnitId: this.valueModal.solicitationData.businessUnitId,
        statusStr: '',
      }

      if (obj.status == 0) {
        obj.statusStr = 'Não definido'
      }

      if (obj.status == 1) {
        obj.statusStr = 'Pendente'
      }

      if (obj.status == 2) {
        obj.statusStr = 'Em progresso'
      }

      if (obj.status == 3) {
        obj.statusStr = 'Concluído'
      }

      if (obj.status == 4) {
        obj.statusStr = 'Cancelado'
      }

      REQUEST_SERVICE.put(CHANGE_STATUS_SUMMARY, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CARD_DETAILS:", response.data);

          $("#update-solicitation").modal('hide');
          swal("Successo", 'Dados alterados com sucesso!', "success");
          this.loading = false;
          this.newNote = '';

          this.runFunction();
        })
        .catch((reason) => {
          this.loading = false;

          $("#update-solicitation").modal('hide');
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    }
  }
}
</script>

<style lang="scss" scoped>

#update-solicitation {
  .modal-dialog {
    width: 455px;
    margin-top: 100px;

    .content {
      border: none;
      box-shadow: none;
      border-radius: 8px !important;
      padding: 30px;

      .modal-header {
        position: relative;
        padding: 0;
        border-bottom: none;

        .title-group {
          .title-modal {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #191919;
            padding-bottom: 10px;
            border-bottom: 1px solid #E6E9EC;
          }
        }

        .close-btn-solicitation {
          position: absolute;
          right: -3px;
          top: -3px;
          height: 20px;
          color: #BACADC;

          &:hover {
            color: #a0adbd;
          }

          ion-icon {
            font-size: 20px;
            pointer-events: none;
          }
        }
      }

      .modal-body {
        padding: 0;

        .body-default {
          display: flex;
          flex-direction: column;
          margin-top: 20px;

          span {
            font-size: 14px;
            color: #191919;
            font-weight: 400;
            line-height: 19.69px;
            margin-bottom: 15px;

            &:last-child {
              margin-bottom: 0;
            }

            b {
              font-weight: 700;
            }
          }
        }

        .body-input {
          margin-top: 20px;

          .form-textarea {
            margin-top: 20px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            textarea {
              min-height: 67px !important;
              max-height: 67px !important;
              min-width: 100% !important;
              max-width: 100% !important;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }

          .form-select {
            display: flex;
            flex-direction: column;
            padding: 0;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .form-select-input {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;
              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .form-text {
            display: flex;
            flex-direction: column;
            padding: 0;
            margin-top: 20px;

            &:first-child {
              margin-top: 0;
            }

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);

              span {
                position: absolute;
                right: 0;
                top: 0;
                font-size: 11px;
                color: var(--light-red);
              }
            }

            .form-text-input {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }
        }

        .input-btn {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 30px;

          .btn-cancel {
            padding: 9px 16px;
            border-radius: 4px !important;
            background: #D5DFEB;
            color: #3a424e;
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
            transition: .2s;
            margin-right: 15px;

            &:hover {
              background: #bbbec2fc;
            }
          }

          .btn-save {
            display: flex;
            width: 109px;
            justify-content: center;
            align-items: center;
            height: 36.2px;
            border: none;
            background: #2F23D6;
            color: #FFFFFF;
            border-radius: 4px !important;
            transition: .2s;

            &:hover {
              background: #20179e !important;
            }

            &:disabled {
              cursor: no-drop;
              filter: grayscale(1);
            }
          }
        }
      }
    }
  }
}

.spinner-btn {
  height: 19px;
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalUpdateSolicitation.vue